import { useEffect, useState } from 'react'
import { getProjectQuotesV2 } from '@/components/features/project-detail/quotes/quotes-v2.api'
import type { ProjectQuotesV2Response } from '@/components/features/project-detail/quotes/types'

export function useProjectQuotesV2(projectId: string | undefined) {
  const [data, setData] = useState<ProjectQuotesV2Response | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)

  const refetch = async () => {
    if (!projectId) return
    setIsLoading(true)
    setError(null)

    try {
      const d = await getProjectQuotesV2(projectId)
      setData(d)
    } catch (e) {
      setError(e)
      setData(null)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!projectId) return

    let cancelled = false
    setIsLoading(true)
    setError(null)

    getProjectQuotesV2(projectId)
      .then((d) => {
        if (cancelled) return
        setData(d)
      })
      .catch((e) => {
        if (cancelled) return
        setError(e)
        setData(null)
      })
      .finally(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [projectId])

  return { data, isLoading, error, refetch }
}
